import React from "react";
import { EditorState, Modifier } from "draft-js";
import { RichUtils } from "draft-js";

const Toolbar = ({ editorState, setEditorState }) => {
  const applyStyle = (style) => {
    setEditorState(RichUtils.toggleInlineStyle(editorState, style));
  };

  const applyBlockType = (blockType) => {
    setEditorState(RichUtils.toggleBlockType(editorState, blockType));
  };

  const addLink = () => {
    const selection = editorState.getSelection();
    if (!selection.isCollapsed()) {
      const link = prompt("Enter a URL:", "http://");
      if (link) {
        const contentState = editorState.getCurrentContent();
        const contentStateWithEntity = contentState.createEntity(
          "LINK",
          "MUTABLE",
          { url: link }
        );
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
        const newEditorState = EditorState.set(editorState, {
          currentContent: contentStateWithEntity,
        });
        const linkedState = RichUtils.toggleLink(
          newEditorState,
          selection,
          entityKey
        );
        setEditorState(
          EditorState.forceSelection(linkedState, linkedState.getSelection())
        );

        // Apply green color only to the selected linked text
        const updatedContentState = Modifier.applyInlineStyle(
          linkedState.getCurrentContent(),
          linkedState.getSelection(),
          "GREEN"
        );
        setEditorState(
          EditorState.push(
            linkedState,
            updatedContentState,
            "change-inline-style"
          )
        );
      }
    }
  };

  const removeLink = () => {
    const selection = editorState.getSelection();
    if (!selection.isCollapsed()) {
      // Remove the link entity
      let newEditorState = RichUtils.toggleLink(editorState, selection, null);

      // Remove the "GREEN" style when unlinking
      const contentState = newEditorState.getCurrentContent();
      const contentStateWithoutGreen = Modifier.removeInlineStyle(
        contentState,
        selection,
        "GREEN"
      );

      newEditorState = EditorState.push(
        newEditorState,
        contentStateWithoutGreen,
        "change-inline-style"
      );

      setEditorState(
        EditorState.forceSelection(newEditorState, selection)
      );
    }
  };

  return (
    <div className="mb-4 grid grid-cols-6 space-x-2 space-y-2">
      <button
        onClick={() => applyStyle("BOLD")}
        type="button"
        className="px-2 py-1 border bg-gray-200"
      >
        Bold
      </button>
      <button
        onClick={() => applyStyle("ITALIC")}
        type="button"
        className="px-2 py-1 border bg-gray-200"
      >
        Italic
      </button>
      <button
        onClick={() => applyBlockType("unstyled")}
        type="button"
        className="px-2 py-1 border bg-gray-200"
      >
        P
      </button>
      <button
        onClick={() => applyBlockType("header-one")}
        type="button"
        className="px-2 py-1 border bg-gray-200"
      >
        H1
      </button>
      <button
        onClick={() => applyBlockType("header-two")}
        type="button"
        className="px-2 py-1 border bg-gray-200"
      >
        H2
      </button>
      <button
        onClick={() => applyBlockType("header-three")}
        type="button"
        className="px-2 py-1 border bg-gray-200"
      >
        H3
      </button>
      <button
        onClick={() => applyBlockType("unordered-list-item")}
        type="button"
        className="px-2 py-1 border bg-gray-200"
      >
        UL
      </button>
      <button
        onClick={() => applyBlockType("ordered-list-item")}
        type="button"
        className="px-2 py-1 border bg-gray-200"
      >
        OL
      </button>
      <button
        onClick={addLink}
        type="button"
        className="px-2 py-1 border bg-gray-200"
      >
        Add Link
      </button>
      <button
        onClick={removeLink}
        type="button"
        className="px-2 py-1 border bg-gray-200"
      >
        Unlink
      </button>
    </div>
  );
};

export default Toolbar;
